import {
    Component, Mixins, Emit, Vue,
} from 'vue-property-decorator';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import FormsMixin from '@groot-components/shared/mixins/forms/index';
import { digits } from '@groot-nodes/helpers/number';
import direction from '@groot-nodes/helpers/direction';
import Classes from '@groot-components/shared/mixins/classes';
import config from '@groot-components/shared/config';
import { YFieldWrapper } from '@groot-components/field-wrapper';
import Props from './props';

/**
 * @name Phone
 */
@Component({
    components: {
        VuePhoneNumberInput,
        YFieldWrapper,
    },
})
class YPhone extends Mixins(Props, Classes, FormsMixin) {
    /**
     * Props list that active by developer
     */
    activeCommonProps: Array<string> = [];

    /**
     * The css parent class of the component
     */
    parentClass: string = this.componentClass(this.baseClass, config.prefix.phone);

    /**
     * Create Common Props for the phone.
     *
     * @returns {object} - List of props
     */
    get commonProps(): Record<string, any> {
        const commonProps: Record<string, any> = {
            baseClass: this.baseClass,
        };
        this.activeCommonProps.forEach((item) => {
            commonProps[item] = this[item];
        });
        return commonProps;
    }

    /**
     * Create classes array for the phone.
     *
     * @returns {Array} - Array of classes
     */
    get classes(): Array<string> {
        const cls: Array<string> = [];
        cls.push(...this.commonClasses('Phone', this.commonProps, this.baseClass || config.prefix.phone));
        if (this.getBoolean('disabled')) {
            cls.push('is-disabled');
        }
        if (this.getBoolean('readonly')) {
            cls.push('is-readonly');
        }

        // Get Direction Class
        if (this.dir !== 'auto') {
            cls.push(`is-${this.dir}`);
        } else {
            cls.push(direction(this.model) === 'is-rtl' ? 'is-rtl' : 'is-ltr');
        }

        return cls;
    }

    /**
     * Input Classes
     * 
     * @returns {Array} - Array of classes
     */
    get inputClasses(): Array<string> {
        const cls: Array<string> = [`${this.parentClass}__form-field`];

        return cls;
    }

    /**
     * Return the value
     * Return localed digits if 
     * 
     * @returns {string|number}
     */
    get valueShow(): string | number {
        return digits(this.value, this.$i18n.locale);
    }

    /**
     * onComplete
     *
     * @param {string| number} value
     * @returns {string| number}
     */
    @Emit('input')
    onInputValueChanged(value: string | number): string | number {
        return value;
    }

    /**
     * onUpdate
     *
     * @param {object} value
     * @returns {object}
     */
    @Emit('update')
    onInputValueUpdate(value: {[k: string]: any}): {[k: string]: any} {
        return value;
    }
}

export default YPhone;
